import { CircularProgress } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';

import { PublicationApi } from '../../api/publication';
import { Icon } from '../../components';
import { UpButton } from '../../components/Button/UpButton';
import { PublicationItem } from '../../components/PublicationItem';
import { useActions } from '../../hooks/useActions';
import { useMain } from '../../hooks/useMain';
import { usePublication } from '../../hooks/usePublication';
import { fetchMainCatalog } from '../../store/main/main.actions';
import Heading from '../../ui/heading/Heading';

import './Publication.sass';
import { useLazyLoading } from './useLazyLoading';

//Страница публикаций
export const Publication = () => {
  const {
    setPublicationItems,
    setPublicationOffset,
    fetchMainCatalog,
    setPage,
    setProcesses,
  } = useActions();
  const { processes } = useMain();
  const { offset, items } = usePublication();

  const [publicationSwitchActive, setPublicationSwitchActive] = useLocalStorage(
    'publication',
    'grid'
  ); //Активный переключатель
  const [fetching, setFetching] = useState(true); //Загрузка

  const onPublicationSwitch = (name: 'grid' | 'list') =>
    setPublicationSwitchActive(name); //Лимит вывода публикаций
  //Добавление элементов
  const appendItems = useCallback(() => {
    (async () => {
      if (offset !== 0) {
        setFetching(true);
        try {
          const { articles } = await PublicationApi().getLimited(8, offset);
          if (articles.length !== 0) {
            setPublicationOffset(offset + 8);
            setPublicationItems([...items, ...articles]);
          } else {
            setPublicationOffset(0);
            setPublicationItems([...items]);
          }
        } finally {
          setFetching(false);
        }
      }
    })();
  }, [items, setPublicationItems]);

  const [onScroll] = useLazyLoading({
    onIntersection: appendItems,
    delay: 0 /*1200*/, //Из-за задержки 1200 странно работает
  });

  useEffect(() => {
    setPage('publication'); //На какай странице находимся
    fetchMainCatalog(); //Получение процессов
  }, []);
  useEffect(() => {
    setProcesses(processes);
  }, [processes]);

  useEffect(() => {
    if (offset === 0) {
      (async () => {
        const { articles } = await PublicationApi().getLimited(8, offset);
        setPublicationOffset(8);
        setPublicationItems(articles);
      })();
    }
  }, []);

  useEffect(() => {
    // @ts-ignore
    window.addEventListener('scroll', onScroll);
    // @ts-ignore
    return () => window.removeEventListener('scroll', onScroll);
  }, [items]);

  return (
    <div className="publication-page">
      <div className="publication-page__wrapper">
        <div className="breadcrumbs">
          <div className="breadcrumbs__item--red">Главная</div>
          <div className="breadcrumbs__item--gray">/</div>
          <div className="breadcrumbs__item--gray">Публикации</div>
        </div>
        <div className="publication-page__block">
          <Heading title="Публикации" />
          <div className="switch">
            <div onClick={() => onPublicationSwitch('list')}>
              <Icon
                variant={
                  publicationSwitchActive === 'list'
                    ? 'listPublicationActive'
                    : 'listPublication'
                }
              />
            </div>
            <div onClick={() => onPublicationSwitch('grid')}>
              <Icon
                variant={
                  publicationSwitchActive === 'grid'
                    ? 'gridPublicationActive'
                    : 'gridPublication'
                }
              />
            </div>
          </div>
        </div>
        <div className="publication-page__content">
          <div className="publication-page__left">Menu</div>
          <div className="publication-page__right">
            <div
              className={`publication-page-cards ${publicationSwitchActive}`}
            >
              <div className="publication-page-container">
                <div
                  className={`publication-page-cards ${publicationSwitchActive}`}
                >
                  {items.map((results: any) => {
                    return (
                      <PublicationItem
                        key={results.id}
                        {...results}
                        publicationSwitchActive={publicationSwitchActive}
                      />
                    );
                  })}
                </div>
                <div className="publication-page__loading">
                  {fetching && (
                    <CircularProgress style={{ color: '#FF9F2F' }} />
                  )}
                </div>
              </div>
            </div>
            <UpButton className="publication" />
          </div>
        </div>
      </div>
    </div>
  );
};
